import React from "preact/compat";
import { Tabs } from '../../../💠Molecules/Tabs/Tabs';
import { Parlay } from '../../../🔷Organisms/Betslip/Parlay/Parlay';
import { Straight } from '../../../🔷Organisms/Betslip/Straight/Straight';
import { Callout } from "../../../💠Molecules/Callout/Callout"; 
import { MainProps } from "./main.type";

export const Main: React.FunctionComponent<MainProps> = ({
    t,
    site,
    stWager,
    prWager,
    betData,
    system,
    tabState,
    prSelected,
    removeTheGame,
    removeOldGames,
    handleUpdateStraightWager,
    updateParlayWager,
    updateTab,
    updateSelectdParlay
  }) => {
    const tabChange = (event: any) => {
        if (betData.getTotalBets() > 0) {
            updateTab(event.target.text);
        }
    }

    return (
        <div className="betslip-content flex-column">
            {system !== '' ?
                <Callout toggleVisibility={true} className="mt-2 mx-3 px-3 align-items-start icon icon-md" type="danger">
                    <div>
                        <div className='h6 w-75 text-capitalize'>{system}</div>
                        <p className='small w-100 mb-0'>{t.system_messages.api_connection.description}</p>
                    </div>
                </Callout>
            :
                <div className='d-flex flex-column'>
                    <Tabs tabs={t.tabs} site={site} current={tabState} counter={betData.getTotalBets()} onClick={tabChange} />
                    {tabState === t.tabs.tab1 ?
                        <Straight 
                            t={t}
                            site={site}
                            stWager={stWager}
                            betData={betData} 
                            removeGame={removeTheGame}
                            removeOldGames={removeOldGames}
                            handleUpdateStraightWager={handleUpdateStraightWager} />
                    : 
                        <Parlay 
                            t={t}
                            prWager={prWager}
                            site={site}
                            betData={betData} 
                            selected={prSelected}
                            removeGame={removeTheGame}
                            removeOldGames={removeOldGames}
                            updateParlayWager={updateParlayWager}
                            updateSelectdParlay={updateSelectdParlay} />
                    }
                </div>
            }
        </div>
    )
};